import { Res, onQueryHaiIdParams, onSynHaiEnterParams, onSynHaiEnterRes } from '../components/app.type';
import { channelEnum, onSignTokenScene, roleName } from '../constants/app';
import httpClient from '../utils/httpClient';

export const checkHaiAuthorization = async () => {
  return httpClient({
    path: `/sts/role/${roleName}`,
    method: 'GET',
  });
};

export const onSynHaiEnter = async (params: onSynHaiEnterParams): Promise<Res<onSynHaiEnterRes>> => {
  return httpClient({
    path: `/hai/sync/${params.instanceId}/${params.region}`,
    method: 'GET',
  });
};

export const onStartHaiInstance = async (params: Pick<onQueryHaiIdParams, 'spaceKey'>): Promise<Res<any>> => {
  return httpClient({
    path: `/hai/${params.spaceKey}/start`,
    method: 'POST',
  });
};

export const onStatusCheck = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/${spaceKey}/status`,
    method: 'GET',
  });
};

// 通过spaceKey获取instanceId 暂时没用到
export const onQueryHaiId = async (params: onQueryHaiIdParams) => {
  return httpClient({
    path: `/hai/spaceKey/${params.spaceKey}/${params.region}`,
    method: 'GET',
  });
};

export const runWorkspace = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/proxy/run`,
    method: 'PUT',
  });
};

export const queryHaiStatus = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/status`,
    method: 'GET',
  });
};

export const onCheckPing = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/ping`,
    method: 'GET',
  });
};

export const onSignToken = async (spaceKey: string) => {
  return httpClient({
    path: `/token/${onSignTokenScene}?spaceKey=${spaceKey}`,
    method: 'POST',
  });
};

export const onPostRegionUrl = async () => {
  return httpClient({
    path: `/token/${onSignTokenScene}`,
    method: 'GET',
  });
};

export const queryHaiBySpaceKey = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}`,
    method: 'GET',
  });
};
